import { render, staticRenderFns } from "./cloud-selector.vue?vue&type=template&id=2be95bac&scoped=true"
import script from "./cloud-selector.vue?vue&type=script&lang=js"
export * from "./cloud-selector.vue?vue&type=script&lang=js"
import style0 from "./cloud-selector.vue?vue&type=style&index=0&id=2be95bac&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be95bac",
  null
  
)

export default component.exports